(() => {
  const ready = new WeakSet();
  function setup(scope = document) {
    scope.querySelectorAll('[data-aw-size-guide]').forEach(block => {
      if (ready.has(block)) return;
      ready.add(block);
      const root = block.closest('.product-section');
      const trigger = block.querySelector('[data-aw-size-open]');
      const dialog = document.getElementById(trigger.dataset.awSizeOpen);
      const productTable = block.querySelector('[data-aw-product-table] table');
      if (productTable) {
        const headerRow = productTable.tHead?.rows[0] || productTable.rows[0];
        const removed = [...headerRow.cells].map((cell, index) => (!cell.textContent.trim() || /inch|cal[eiy]/i.test(cell.textContent)) ? index : -1).filter(index => index >= 0).reverse();
        [...productTable.rows].forEach(row => removed.forEach(index => row.cells[index]?.remove()));
        if (!productTable.tHead) productTable.createTHead().append(headerRow);
        [...headerRow.cells].forEach((cell, index) => {
          const heading = document.createElement('th');
          heading.scope = 'col';
          heading.textContent = index === 0 ? 'Rozmiar' : cell.textContent.trim().replace(/Klatka piersiowa|Biust/i, 'Obwód biustu').replace(/Długość spódnicy/i, 'Długość').replace(/^Rękaw /i, 'Długość rękawa ').replace(/^Ramiona /i, 'Szerokość ramion ').replace(/\s*\(cm\)/g, ' (cm)');
          cell.replaceWith(heading);
        });
        [...productTable.tBodies].forEach(body => [...body.rows].forEach(row => {
          const cell = row.cells[0];
          if (!cell) return;
          const heading = document.createElement('th');
          heading.scope = 'row';
          heading.textContent = cell.textContent.trim().replace(/^2XL$/, 'XXL').replace(/^3XL$/, 'XXXL');
          cell.replaceWith(heading);
        }));
      }
      const content = dialog.querySelector('.aw-sizeguide-content');
      const tableSections = [...content.querySelectorAll('.aw-sizeguide-table-section')];
      const tables = tableSections.map(section => {
        const table = section.querySelector('table');
        if (!table || !table.tHead) return null;
        return {
          section,
          title: section.querySelector('h3')?.textContent.trim() || '',
          headings: [...table.tHead.rows[0].cells].map(cell => cell.textContent.trim()),
          rows: [...table.tBodies].flatMap(body => [...body.rows]).map(row => [...row.cells].map(cell => cell.textContent.trim()))
        };
      }).filter(table => table && table.rows.length);
      let mobileSelect;
      if (tables.length && dialog.dataset.mobileSimple === 'true') {
        const mobile = document.createElement('div');
        mobile.className = 'aw-sizeguide-mobile';
        const intro = document.createElement('p');
        intro.textContent = content.dataset.mobileIntro;
        const selectLabel = document.createElement('label');
        selectLabel.textContent = content.dataset.mobileChoose;
        mobileSelect = document.createElement('select');
        mobileSelect.id = dialog.id + '-mobile-size';
        selectLabel.htmlFor = mobileSelect.id;
        const sizes = [...new Set(tables.flatMap(table => table.rows.map(row => row[0])))];
        sizes.forEach(size => mobileSelect.add(new Option(size, size)));
        const units = document.createElement('p');
        units.className = 'aw-sizeguide-mobile__units';
        units.textContent = content.dataset.mobileUnits;
        const dimensions = document.createElement('div');
        dimensions.className = 'aw-sizeguide-mobile__dimensions';
        dimensions.setAttribute('aria-live', 'polite');
        function renderDimensions() {
          dimensions.replaceChildren();
          tables.forEach(table => {
            const row = table.rows.find(row => row[0] === mobileSelect.value);
            const section = document.createElement('section');
            const title = document.createElement('h3');
            title.textContent = table.title || content.dataset.mobileDimensions;
            section.append(title);
            if (row) {
              const list = document.createElement('dl');
              table.headings.slice(1).forEach((heading, index) => {
                const pair = document.createElement('div');
                const label = document.createElement('dt');
                label.textContent = heading.replace(/\s*\(cm\)/gi, '').replace(/Klatka piersiowa|Obwód biustu/i, 'Biust').replace(/^Ramiona$/i, 'Szerokość ramion').replace(/^Talia \(góra\)$/i, 'Talia — góra').replace(/^Talia \(spodnie\)$/i, 'Talia — spodnie');
                const value = document.createElement('dd');
                value.textContent = (row[index + 1] || '—').replace(/(\d)\.(\d)/g, '$1,$2');
                pair.append(label, value);
                list.append(pair);
              });
              section.append(list);
            } else {
              const missing = document.createElement('p');
              missing.textContent = content.dataset.mobileMissing;
              section.append(missing);
            }
            dimensions.append(section);
          });
        }
        mobileSelect.addEventListener('change', renderDimensions);
        mobile.append(intro, selectLabel, mobileSelect, units, dimensions);
        const compare = document.createElement('button');
        compare.type = 'button';
        compare.className = 'aw-sizeguide-compare';
        compare.textContent = content.dataset.mobileCompare;
        compare.setAttribute('aria-expanded', 'false');
        const compareSections = tables.map((table, index) => {
          table.section.id = dialog.id + '-compare-' + index;
          return table.section.id;
        });
        compare.setAttribute('aria-controls', compareSections.join(' '));
        const scrollHint = document.createElement('p');
        scrollHint.className = 'aw-sizeguide-compare-hint';
        scrollHint.textContent = content.dataset.mobileScrollHint;
        scrollHint.hidden = true;
        compare.addEventListener('click', () => {
          const expanded = compare.getAttribute('aria-expanded') !== 'true';
          compare.setAttribute('aria-expanded', String(expanded));
          compare.textContent = expanded ? content.dataset.mobileHideTable : content.dataset.mobileCompare;
          dialog.classList.toggle('aw-sizeguide-show-table', expanded);
          scrollHint.hidden = !expanded;
        });
        dialog.addEventListener('close', () => {
          compare.setAttribute('aria-expanded', 'false');
          compare.textContent = content.dataset.mobileCompare;
          dialog.classList.remove('aw-sizeguide-show-table');
          scrollHint.hidden = true;
        });
        mobile.append(compare, scrollHint);
        content.prepend(mobile);
        dialog.classList.add('aw-sizeguide-has-mobile');
        renderDimensions();
        const measuring = content.querySelector('.aw-dress-measuring');
        if (measuring) {
          const details = document.createElement('details');
          details.className = 'aw-sizeguide-measure-details';
          const summary = document.createElement('summary');
          summary.textContent = content.dataset.mobileMeasure;
          measuring.before(details);
          details.append(summary, measuring);
          const media = window.matchMedia('(min-width: 769px)');
          const syncDetails = () => { details.open = media.matches; };
          syncDetails();
          media.addEventListener('change', syncDetails);
        }
      }
      let previousOverflow;
      function placeTrigger() {
        const labels = [...root.querySelectorAll('.swatch-label-button,.variant__label')];
        const target = labels.find(label => /rozmiar|size/i.test(label.textContent) && label.getBoundingClientRect().width > 0);
        if (!target || trigger.parentElement === target) return;
        target.classList.add('aw-sizeguide-label');
        target.append(trigger);
        block.classList.add('aw-sizeguide-ready');
      }
      trigger.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        previousOverflow = document.documentElement.style.overflow;
        if (mobileSelect) {
          const selectedSize = root.querySelector('input[type="radio"][name="Rozmiar"]:checked')?.value;
          const option = [...mobileSelect.options].find(option => option.value === selectedSize || option.value.replace('XXXL', '3XL').replace('XXL', '2XL') === selectedSize);
          if (option) {
            mobileSelect.value = option.value;
            mobileSelect.dispatchEvent(new Event('change'));
          }
        }
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      });
      dialog.querySelector('[data-aw-size-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = previousOverflow || '';
        trigger.focus({preventScroll:true});
      });
      placeTrigger();
      new MutationObserver(placeTrigger).observe(root, {childList:true,subtree:true});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup());
  else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
